import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { parse } from 'date-fns';
import { BeatYourBrokerResultModel } from 'src/app/models/beat-your-broker-result.model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { QuoteModel, AnswerModel } from 'src/app/models/quote.model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { SiteContentService } from 'src/app/services/site-content.service';
import { BeatYourBrokerHelper } from '../apg-beat-your-broker-helper';

@Component({
  selector: 'app-apg-beat-your-broker-result',
  templateUrl: './apg-beat-your-broker-result.component.html',
  styleUrls: ['./apg-beat-your-broker-result.component.scss'],
})
export class ApgBeatYourBrokerResultComponent implements OnInit {
  @Input() quickQuote: QQQuestionnaireViewModel;
  @Output() continue = new EventEmitter<{ date: string }>();
  @Output() back = new EventEmitter();

  mode: 'display-result' | 'display-quote-result' | 'contact-request' | 'contact-complete' = 'display-result';
  loading: boolean;
  error: string;
  answersObject: any;
  quote: QuoteModel;
  result: BeatYourBrokerResultModel;
  colorArray: string[];
  class: '' | 'wide' = '';

  constructor(
    private analyticsService: AnalyticsService,
    private siteContentService: SiteContentService,
    private helper: BeatYourBrokerHelper
  ) { }

  async ngOnInit() {
    await this.getResults();
  }

  async getResults() {
    this.loading = true;
    this.quote = null;
    this.answersObject = this.quickQuote.answersObject;

    try {
      const rsp = await this.helper.getQuote(this.quickQuote);

      if (rsp.error) {
        this.error = rsp.error;
        return;
      }

      this.quickQuote.saveAnswer("Uid", rsp.quote.result.uid);
      this.quote = rsp.quote;

      this.result = this.helper.calculateResult(this.quote);
      if (!this.result.hasCover)
        this.quickQuote.saveAnswer("CurrentPremium", "");

      if (this.result.canBetter)
        this.analyticsService.logLead(this.quickQuote, this.quote.result, 'beat_your_broker');

      this.mode = this.result.displayQuote ? 'display-quote-result' : 'display-result';
      this.class = this.result.displayQuote ? 'wide' : '';
      if (this.mode == 'display-quote-result')
        this.setupPieChartData();

      this.helper.triggerResult(rsp.quote, this.mode, this.class);

    } catch (err) {
      let content = await this.siteContentService.getSiteContent("BeatYourBroker.ApiAccessError");
      this.error = content.body;
    } finally {
      this.loading = false;
    }
  }

  setupPieChartData() {
    this.colorArray = ['#FFFFFF', '#132C40'];
  }

  async next() {
    if (this.mode == 'display-quote-result')
      this.mode = 'contact-request'
  }

  newQuote() {
    this.quickQuote.quoteKey = null;
    this.result = null;
    this.back.emit();
  }

  setAnswer(answers: AnswerModel[], key: string, value: string) {
    const answer = answers.find(x => x.key == key);
    if (answer)
      answer.value = value;
    else
      answers.push(new AnswerModel(key, value));
  }

  getTitle(policyType: string) {
    if (policyType === 'TERM-CI')
      return "Term Life with Multi-Claim Critical Illness Cover";
    return "Term Life Cover";
  }

  async saveContactRequest(model: QQQuestionnaireViewModel) {
    this.loading = true;
    try {
      const dateStr = `${model.answersObject['ContactDate']} ${model.answersObject['ContactTimeslot']}`.trim();
      const preferredContactDate = dateStr ? parse(dateStr, 'yyyy-MM-dd HH:mm', 0) : null;

      await this.helper.saveContactDate(this.quote.key, preferredContactDate);

      let dateTime = preferredContactDate.toLocaleDateString('en-GB', { month: 'long', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
      this.continue.emit({ date: dateTime });
    }
    catch (err) {
      let content = await this.siteContentService.getSiteContent("QuickQuote.ApiAccessError");
      this.error = content.body;
      this.analyticsService.logFailedLead(this.quickQuote);
    }
    finally {
      this.loading = false;
    }
  }

}
